/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Section,
    Typography,
} from 'wanderu-components';

import ImageModal from '../ImageModal';

import styles from './TerminalOverview.scss';

const propTypes = {
    description: PropTypes.string,
    location: PropTypes.shape({
        city: PropTypes.string,
        hours: PropTypes.string,
        name: PropTypes.string,
        notes: PropTypes.string,
        phone: PropTypes.string,
        stateCode: PropTypes.string,
        stateName: PropTypes.string,
        street1: PropTypes.string,
        zipcode: PropTypes.number,
    }),
    namespace: PropTypes.string,
    stationImages: PropTypes.array,
    title: PropTypes.string,
};

const defaultProps = {
    description: '',
    location: {},
    namespace: '',
    stationImages: [],
    title: '',
};

const TerminalOverview = (props) => {
    const {
        description,
        id,
        location,
        stationImages,
        title,
    } = props;

    const [imageToDisplay, setImageToDisplay] = useState();

    function dismissModal() {
        setImageToDisplay(undefined);
    }

    function showModal(index) {
        setImageToDisplay(index);
    }

    return (
        <Section
            className={styles.stationPageSection}
            id={id}
        >
            {imageToDisplay !== undefined && (
                <ImageModal
                    dismissModal={dismissModal}
                    image={stationImages[imageToDisplay]}
                />
            )}
            <div className={styles.terminalContainer}>
                <div className={styles.terminalText}>
                    <div className={styles.about}>
                        <Typography variant="h3">{title}</Typography>
                        <Typography
                            component={MarkdownContent}
                            paragraph
                        >
                            {description}
                        </Typography>
                    </div>
                    <div className={styles.terminalAddress}>
                        <Typography className={styles.boldFont}>
                            {location.street1}
                        </Typography>
                        <Typography className={styles.boldFont}>
                            {`${location.city}, ${location.stateCode} ${location.zipcode}`}
                        </Typography>
                        <Typography>
                            {`${location.phone}`}
                        </Typography>
                        <br />
                        <Typography className={styles.boldFont}>
                            Hours
                        </Typography>
                        <Typography>
                            {location.hours}
                        </Typography>
                        <br />
                        <Typography className={styles.italic}>
                            {`${location.notes}`}
                        </Typography>
                    </div>
                </div>
                <div className={styles.images}>
                    {stationImages.map((image, index) => (
                        <img
                            alt={image?.metadata?.alt || ''}
                            className={styles.terminalImg}
                            key={image.url}
                            onClick={() => showModal(index)}
                            src={image.url}
                            title={image?.metadata?.alt || ''}
                        />
                    ))}
                </div>
            </div>
        </Section>
    );
};

TerminalOverview.propTypes = propTypes;
TerminalOverview.defaultProps = defaultProps;

export default TerminalOverview;
